export default __webpack_public_path__ + "assets/hurricane.bf143542.svg";